window.showResponse = function(text) {
    $('#snackbar .content').html(text);
    $('#snackbar').fadeIn(2000, function() {
        $(this).fadeOut(1000);
    });
}

window.number_format = function(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
window.formatNumber=function ($number){
    if(typeof $number == 'string'){
      if($number.indexOf(".") > 0){
        $number = String($number).replace(new RegExp(escapeRegExp("."), 'g'), "");
      }
    }
  
    $number = parseInt($number) || "";
    return String($number).replace(/(.)(?=(\d{3})+$)/g,'$1.');
  }
window.getNumber = function ($number){
    if(typeof $number == 'string'){
        $number=String($number).replace(new RegExp(escapeRegExp("."), 'g'), "");
        $number=parseInt($number);
    }
    return $number;
}
window.escapeRegExp = function(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}